<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title
          >スマホアプリ/CS管理(AppMedia TOPページ)</v-toolbar-title
        >
        <v-divider class="mx-2 mr-4 pr-4" inset vertical></v-divider>

        <v-btn color="primary" outlined dark @click="newData()">
          + 新規カテゴリ登録
        </v-btn>

        <v-row>
          <v-col cols="2" class="pt-4"
            ><v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="1000px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5" v-if="editItem.id == -1"
                      >新規登録</span
                    >
                    <span class="text-h5" v-else>編集</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <table width="100%">
                        <tr>
                          <td colspan="2" align="center" justify="center">
                            <img
                              erro
                              width="60"
                              height="60"
                              :src="'https://appmedia.jp' + editItem.img_pass"
                            />
                          </td>
                        </tr>
                        <tr v-show="editItem.id > 0">
                          <th class="pa-2" width="130">ID</th>
                          <td>
                            {{ editItem.id }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pa-2" width="130">タイトル</th>
                          <td>
                            <v-text-field
                              v-model="editItem.title"
                            ></v-text-field>
                          </td>
                        </tr>

                        <tr>
                          <th class="pa-2">画像</th>
                          <td>
                            <v-text-field
                              v-model="editItem.img_pass"
                              hide-details=""
                            ></v-text-field>
                            <span class="red--text"
                              >/wp-content/から指定する</span
                            >
                          </td>
                        </tr>

                        <tr>
                          <th class="pa-2">URL</th>
                          <td>
                            <v-text-field v-model="editItem.url"></v-text-field>
                          </td>
                        </tr>
                        <tr>
                          <th class="pa-2">AppleStoreID</th>
                          <td>
                            <v-text-field
                              v-model="editItem.appstore_id"
                            ></v-text-field>
                          </td>
                        </tr>

                        <tr>
                          <th class="pa-2">タイプ</th>
                          <td>
                            <v-radio-group v-model="editItem.type" row>
                              <v-radio
                                label="スマホアプリ"
                                value="appli"
                              ></v-radio>

                              <v-radio
                                label="コンシューマ(CS)"
                                value="cs"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>
                      </table>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      キャンセル
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save()">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog></v-row
            ></v-col
          >
          <v-col>
            <v-card-subtitle
              style="font-size:18px; padding-top:18px; color:red;"
              >{{ target_env }}</v-card-subtitle
            >
          </v-col>
        </v-row>
      </v-toolbar>
    </div>

    <v-btn color="primary" outlined dark @click="dataApply()">
      本番反映
    </v-btn>

    <!-- 未保存データチェックのためにv-tagは利用しない(監視が難しいため) -->
    <div class="type_change_area">
      <v-btn
        v-bind:class="['type_select', { select: !type_change }]"
        @click="changeType(0)"
        >スマホアプリ</v-btn
      >
      <v-btn
        v-bind:class="['type_select', { select: type_change }]"
        @click="changeType(1)"
        >コンシューマゲーム</v-btn
      >
    </div>
    <!-- <span>スマホアプリ</span>

    <v-tabs
      v-model="type_change"
      background-color="transparent"
      color="basil"
      grow
    >
      <v-tab key="appli">スマホアプリ</v-tab>
      <v-tab key="cs">コンシューマゲーム</v-tab>
    </v-tabs>
    <v-tabs-items v-model="type_change">
      <v-tab-item key="appli">aaaa</v-tab-item>
      <v-tab-item key="cs">cccc</v-tab-item>
    </v-tabs-items> -->

    <!-- <v-tabs-items v-model="tab">
<v-tab-item :key="appli" >
<v-card
  color="basil"
  flat
>
</v-card>
</v-tab-item>
</v-tabs-items> -->

    <v-row align="center" justify="center">
      <v-col>
        <ul style="list-style:none;">
          <draggable v-model="listItems" draggable=".item" group="items">
            <li
              v-for="item in listItems"
              :key="item.id"
              class="item pa-1"
              max-width="100"
              style="display:inline-block; width: calc(100% /6);vertical-align: top;"
            >
              <v-card
                style="height: 100px"
                class="pt-2"
                @click="editData(item)"
              >
                <div style="text-align: center;">
                  <div>
                    <img
                      class="ma-1"
                      width="55"
                      height="55"
                      :src="'https://appmedia.jp' + item.img_pass"
                    />
                  </div>

                  <span style="font-size:12px; line-height:1.3; display:block">
                    {{ item.title }}</span
                  >
                </div>
              </v-card>
            </li>
          </draggable>
        </ul>

        <!-- <v-data-table
          :headers="headers"
          :items="listItems"
          hide-default-footer
          :items-per-page="100"
        >
          <template v-slot:body="{ items }">
            <tbody
              v-model="listItems"
              is="draggable"
              tag="tbody"
              class="text-center"
            >
              <tr v-for="(item, i) in items" :key="i">
                <td width="60">
                  <v-btn outlined class="transparent" @click="editData(item)">
                    <v-icon small color="primary">fas fa-edit</v-icon>
                  </v-btn>
                </td>

                <td width="60">{{ item.id }}</td>
                <td width="100">
                  <img
                    class="ma-1"
                    width="48"
                    height="48"
                    :src="'https://appmedia.jp' + item.img_pass"
                  />
                </td>
                <td class="text-left">{{ item.title }}</td>
                <td>{{ item.url }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table> -->
      </v-col>
    </v-row>
  </div>
</template>
<script>
// Ajax通信ライブラリ
import axios from "axios";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },

  data() {
    return {
      type_change: 0, // 0: appli   1: cs

      editedIndex: -1,
      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "70px",
        },

        { text: "ID", sortable: false, align: "center", value: "id" },
        { text: "img", sortable: false, align: "center", value: "img_pass" },

        { text: "タイトル", sortable: false, align: "center", value: "title" },
        { text: "URL", sortable: false, align: "center", value: "url" },
      ],

      editItem: {
        id: -1,
        img_pass: "aaa",
        title: "dd",
        appstore_id: "ddd",
        type: "ddd",
        url: "ddd",
      },

      listItems: [],
      checkItems: [], //未保存の判定データ

      allGameDatas: [],

      allItems: [],

      search: "",
      // headers: [
      //   {
      //     text: "編集",
      //     align: "center",
      //     value: "edit",
      //     sortable: false,
      //     width: "70px",
      //   },
      //   {
      //     text: "id",
      //     value: "id",
      //     align: "center",
      //     width: "100px",
      //   },
      //   { text: "name", value: "name" },
      //   { text: "作成日", value: "create_date" },
      //   { text: "更新日", value: "update_date" },
      //   { text: "ショートコード", value: "code", width: "200px" },
      // ],

      target_env: "", //DBの向き先

      rules: [(value) => !!value || "入力必須"],

      new_create_flg: false,

      showDialog: false,
      // tab: 1,
      items_tab: 0,
      categorySelect: [],

      nameList: [],

      items: [],
      alldatas: [],
      before_datas: "[]", //修正前のデータ

      target_name: "",
      target_category: "",

      dialog: false,
      loading: false,
      shortcode: "",

      new_category: "",
      new_linkcodename: "",
      text: "",
      name: "",

      error_name: "",
      csvMode: false,
      message: "",
      workers: [],
      saveFlg: false,
    };
  },

  beforeCreate: function() {
    this.loading = true;
    axios
      .get(process.env.VUE_APP_APPCATEGORY_LIST, {
        params: {},
      })
      .then((response) => {
        // this.items = response.data;
        this.allGameDatas = response.data;
        this.listItems = this.allGameDatas["appli"];
        // console.log(response)

        this.checkItems = JSON.stringify(this.listItems);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {},

  watch: {
    // type_change: function(val) {
    //   console.log(this.checkItems)
    // },
  },

  created: function() {
    // this.initItem();
    this.mainDisplay = true;
    this.target_env = process.env.VUE_APP_LINKCODE_LIST_CATEGORY;
    if (this.target_env.indexOf("tool-test") > -1) {
      this.target_env = "テストDB接続中";
    } else {
      this.target_env = "本番DB接続中";
    }
  },

  methods: {
    changeType(val) {
      if (val == this.type_change) {
        return;
      }
      var check1 = this.checkItems;
      var check2 = JSON.stringify(this.listItems);
      if (check1 != "[]" && check1 != check2) {
        if (
          !window.confirm(
            "変更が保存されていません。移動すると変更内容が失われます。"
          )
        ) {
          return true;
        }
      }

      if (val == 0) {
        this.listItems = this.allGameDatas["appli"];
      } else {
        this.listItems = this.allGameDatas["cs"];
      }

      this.checkItems = JSON.stringify(this.listItems);

      this.type_change = val;
    },

    //データの新規追加・更新
    save() {
      this.loading = true;

      var self = this;
      console.log(self.listItems[0].title);
      console.log(self.checkItems[0].title);
      axios
        .post(process.env.VUE_APP_APPCATEGORY_UPDATE, {
          data: this.editItem,
        })
        .then((val) => {
          console.log(val);
          alert("保存しました！");
          if (self.editedIndex != -1) {
            Object.assign(self.listItems[self.editedIndex], self.editItem);
          } else {
            self.listItems.push(self.editItem);
          }
        })
        .catch((error) => {
          alert("名称が空か空白が設定されています\n" + error);
        })
        .finally(() => {
          this.loading = false;
          this.dialog = false;

          console.log(self.listItems[0].title);
          console.log(self.checkItems[0].title);

          self.listItems[0].title = "WWWWWW";
          console.log(self.listItems[0].title);
          console.log(self.checkItems[0].title);
        });
    },

    //データを本番に適用する
    dataApply() {
      axios
        .post(process.env.VUE_APP_APPCATEGORY_APPLY, {
          data: this.listItems,
        })
        .then((val) => {
          console.log(val);
          this.checkItems = JSON.stringify(this.listItems);

          alert("保存しました！");
        })
        .catch((error) => {
          alert("名称が空か空白が設定されています\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    newData() {
      var tmp_type = "";
      if (this.type_change == 0) {
        tmp_type = "appli";
      } else {
        tmp_type = "cs";
      }

      var item = {
        id: -1,
        img_pass: "",
        title: "",
        appstore_id: "",
        type: tmp_type,
        url: "",
      };

      this.editItem = item;

      this.dialog = true;
    },

    editData(item) {
      this.editedIndex = this.listItems.indexOf(item);
      this.editItem = Object.assign({}, item);
      if (this.editItem.type == "" || this.editItem.type == 0) {
        this.editItem.type = "appli";
      }

      this.dialog = true;
    },

    //アイテム削除
    deleteData(item) {
      console.log(item);
    },

    reset: function() {
      this.saveFlg = false;
      this.target_name = "";
      this.items = [];
      this.before_datas = "[]";
      this.shortcode = "";
      this.new_create_flg = false;
    },

    //初期アイテム
    initItem: function() {
      var tmp = {
        additem: false,
        start_date: "",
        end_date: "",
        text: "",
        mode: false, // false : html形式,  true : csv形式
      };
      this.items.push(tmp);
    },

    //追加アイテム（時限設定付き）
    addItem() {
      if (this.items.length > 2) {
        alert("時限式は最大2つまでしか設定できません");
        return;
      }

      var item = {
        additem: true,
        start_date: "",
        end_date: "",
        text: "",
        delete_flg: 0,
      };
      this.items.push(item);

      //タブ切替
      this.items_tab = this.items.length - 1;
    },

    convertMarkdownToHtml: function(item) {
      // var check1 = JSON.stringify(this.before_datas)
      // var check2 = JSON.stringify(this.items)

      // console.log(check1)
      // console.log(check2)

      const replaced = item.text.replace(
        /"\/wp-content/g,
        "https://appmedia.jp/wp-content"
      );

      return replaced;
    },

    //リンクコードの新規作成
    createLinkCode() {
      this.reset();
      this.new_create_flg = true;
      this.initItem();
      this.target_id = -1;

      this.showDialog = true;
    },

    copyItem(item) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(this.dispShortCode2(item))
          .then(() => {
            alert(
              "ショートコードをコピーしました。そのまま記事に貼り付けてください"
            );
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        console.log("ローカル環境はコピーは使えません！");
      }
    },

    //CSVファイルのの読み込み
    loadCsvFile(index, e) {
      console.log(index);

      let vm = this;
      vm.workers = [];
      vm.message = "";
      let file = e.target.files[0];

      if (!file.type.match("text/csv") && !file.type.match("text/plain")) {
        vm.message = "CSVやテキストファイルを選択してください";
        return;
      }

      let reader = new FileReader();
      reader.readAsText(file);

      reader.onload = () => {
        // let lines = reader.result.split("\n");
        // lines.shift();
        // let linesArr = [];
        // for (let i = 0; i < lines.length; i++) {
        //   linesArr[i] = lines[i].split(",");
        // }
        // vm.workers = linesArr;

        this.items[index].text = reader.result;
      };
    },

    loadLinkCode(item) {
      this.target_id = item.id;
      this.target_name = item.name;
      this.new_create_flg = false;
      this.items = [];
      if (this.alldatas[item.name] == null) {
        var tmp = {
          additem: false,
          start_date: "",
          end_date: "",
          text: "",
        };
        this.items.push(tmp);
      }

      if (this.alldatas[item.name].length <= 0) {
        return;
      }

      // this.alldatas[item].forEach((val) => {
      var content = this.alldatas[item.name][0].text;

      // this.dispShortCode(this.alldatas[item.name][0].id, item.name);

      var saveData = JSON.parse(content);

      saveData.default.forEach((val2) => {
        var tmp = {
          additem: false,
          start_date: "",
          end_date: "",
          text: val2.text,
        };
        this.items.push(tmp);
      });

      saveData.timer.forEach((val2) => {
        var tmp = {
          additem: true,
          start_date: val2.start,
          end_date: val2.end,
          text: val2.text,
        };
        this.items.push(tmp);
      });

      this.before_datas = JSON.stringify(this.items);

      this.showDialog = true;
    },

    addCategory() {
      this.categorySelect.push(this.new_category);
      this.target_category = this.new_category;
      this.dialog = false;
    },

    deleteItem(index) {
      if (window.confirm("選択したアイテムを削除します")) {
        this.items.splice(index, 1);
      }
    },

    getLinkCodeListByCategory() {
      var self = this;
      if (this.target_category == "") {
        return;
      }

      var tmp_name = this.target_name;

      this.loading = true;

      this.nameList = [];

      axios
        .get(process.env.VUE_APP_LINKCODE_LIST_NAME, {
          params: { category: self.target_category },
        })
        .then((response) => {
          // this.nameList = response.data.namelist;
          this.alldatas = response.data.data;

          //  console.log(this.alldatas)
          Object.keys(this.alldatas).forEach((key) => {
            this.nameList.push(this.alldatas[key][0]);
          });
          if (this.tab == 1) {
            this.target_name = tmp_name;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 未保存チェック
    checkSaveAction() {
      var check1 = this.before_datas;
      var check2 = JSON.stringify(this.items);
      if (check1 != "[]" && check1 != check2) {
        if (
          !window.confirm(
            "変更が保存されていません。移動すると変更内容が失われます。"
          )
        ) {
          return true;
        }
      }

      this.showDialog = false;
    },

    dispShortCode2(data) {
      this.shortcode =
        '[common_new_linkcode category="' +
        this.target_category +
        '" name="' +
        data.name +
        '" filename=' +
        data.id +
        "]";
    },

    // dispShortCode(id, name) {
    //   this.shortcode =
    //     '[common_new_linkcode category="' +
    //     this.target_category +
    //     '" name="' +
    //     name +
    //     '" filename=' +
    //     id +
    //     "]";
    // },

    messageShortCode(i) {
      if (i == "" && this.tab == 0) {
        return "<span style='color:green;font-size:90%'>新規登録時は、保存後に表示されます</span>";
      }
      return i;
    },

    displayName(i) {
      if (i == 0) {
        return "デフォルト";
      } else {
        return "時限式設定(" + i + ")";
      }
    },
  },

  // //  //描写前の処理（一覧表示）
  // async asyncData({ app }) {
  //   var response = [];
  //   const baseUrl =
  //     "https://article.matomeroyal.com/wp-json/appmedia/tool/review_category_list";
  //   response = await app.$axios.$get(baseUrl);
  //   return {
  //     category: response
  //   };
  // }
};
</script>
<style>
.type_change_area {
  text-align: center;
}
.type_change_area button {
  width: 200px;
  margin: 4px 10px;
  border: none;
  box-shadow: none;
  border-radius: 0;
}
.type_change_area button span {
  font-size: 16px;
  font-weight: bold;
}

.type_select.select {
  border-bottom: 3px solid #2196f3;
  color: #2196f3;
}
</style>
